import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { CustomEmailProvider, CustomProviderTabs } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useConfig } from '../../../contexts/config';
import { useCurrentProject } from '../../../contexts/settings';
import { RouteParams } from '../../../routes/types';

const EmailCustomProvider = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { currentProjectFetching, error } = useCurrentProject(projectId);
  const { xsollaAnalytics } = useConfig();

  useEffect(() => {
    if (!error) {
      xsollaAnalytics.sendOpen('login_pa_module__provider_email_open', projectId);
    }
  }, [error]);

  if (currentProjectFetching) {
    return <Preloader />;
  }

  if (error) {
    return <ToDashboardError error={error} pageName="provider_email_open" />;
  }

  return (
    <CustomProviderTabs>
      <CustomEmailProvider />
    </CustomProviderTabs>
  );
};

export default withRouter(EmailCustomProvider);
